import styled from "@emotion/styled";
import { ErrorMessage } from "@ui/components/common/error-message";
import { stack } from "@ui/style";
import { isNotNil } from "@utils/assert";
import React from "react";

interface FormFieldProps {
	title?: string;
	errorMessage?: string;
	className?: string;
	children: React.ReactNode;
}

export const FormField: React.FC<FormFieldProps> = ({ children, title, errorMessage, className }) => (
	<Container className={className}>
		{isNotNil(title) && <Title className="p-size-m">{title}</Title>}
		{children}
		{isNotNil(errorMessage) && <StyledErrorMessage>{errorMessage}</StyledErrorMessage>}
	</Container>
);

const Container = styled.div`
	${stack(8, "flexstart", "stretch")};
`;

const Title = styled.label`
	margin-bottom: 8px;
`;

const StyledErrorMessage = styled(ErrorMessage)``;
